import { Vacation } from "../_modelsTS/Vacation";

export class VacationMapper {
    static allServerToLocal(serverVacation = []) {
        return serverVacation.map(this.serverToLocal);
    }
    
    static serverToLocal(serverVacation): Vacation {
        return {
            uid: serverVacation.uid,
            begin: new Date(serverVacation.begin),
            end: new Date(serverVacation.end),
            isValid: serverVacation.is_valid,
            type: serverVacation.type
        };
    }
}